import { useCallback, useRef } from 'react';
// simulate scroll animation using transform3d and redo transform - after showing animation -
// and scroll to scrollTop without animation
export function useScrollAnimation(scrollbar) {
    const isAnimationActive = useRef(false);
    const animate = (to, duration = 200, cb) => {
        if (isAnimationActive.current === true) {
            return;
        }
        const track = scrollbar.current;
        isAnimationActive.current = true;
        const { scrollTop } = track;
        const scrollable = track.firstChild;
        const animation = scrollable.animate([
            {
                transform: `translate3d(0, ${0}px, 0)`,
            },
            {
                transform: `translate3d(0, ${scrollTop - to}px, 0)`,
            },
        ], {
            duration,
            fill: 'both',
            easing: 'cubic-bezier(0.7,-0.4, 0.4, 1.4)',
        });
        const undoAnimation = () => {
            return scrollable.animate([
                {
                    transform: `translate3d(0, ${-scrollTop}px, 0)`,
                },
                {
                    transform: `translate3d(0, ${0}px, 0)`,
                },
            ], {
                duration: 0,
                fill: 'both',
            });
        };
        function setScrollTopValue() {
            track.scroll({ top: to, behavior: 'auto' });
        }
        animation.onfinish = () => {
            setScrollTopValue();
            undoAnimation();
            setTimeout(() => {
                isAnimationActive.current = false;
                if (typeof cb === 'function')
                    cb();
            }, 15);
        };
    };
    const animateScroll = useCallback(animate, [scrollbar.current]);
    return {
        animateScroll,
        isAnimationActive: isAnimationActive.current,
    };
}
